import { Component } from '@angular/core';
import { NavController, NavParams, ModalController,LoadingController,ViewController,Events,AlertController } from 'ionic-angular';
import {DatePipe} from '@angular/common';
import {
  LeafletmapPage
} from '../../pages/leafletmap/leafletmap';

@Component({
  selector: 'page-paths-list',
  templateUrl: 'paths-list.html',
})
export class PathsList {

  public paths: any[] = [];
  public path:any;
  private n:number = 0;

  constructor(public navCtrl: NavController, public navParams: NavParams, public viewCtrl: ViewController,public events: Events,
    private alertCtrl: AlertController) {
    //this.paths = navParams.get('paths');
   // console.log(this.paths);
     this.events.subscribe('listPath', (path) => {
     if (path){
       console.log(path);
        console.log(path.length);
       if (path.length == 0 && this.n == 0)
        {
      let alert = this.alertCtrl.create({
    title: 'Aucun résultat',
    subTitle: 'Choisissez une autre plage de dates',
    buttons: ['OK']
  });
  alert.present();
  this.n = 1;
    }else
       {
         this.paths = path;
         this.n = 0;
       }
        
     }
});
    this.callPathlist();
    console.log(this.paths);
        events.subscribe('path', () => {
    this.publishPath();
});



  }

   ngOnInit() {

   }

  callPathlist(){
this.events.publish("TrajetList");
}

  drawPath(path: any){
    this.viewCtrl.dismiss(path);
  }

  closeModal(){
    this.viewCtrl.dismiss(1);
  }

  returnModal(){
    this.viewCtrl.dismiss(null);
  }

seeOnMap(path){
  this.path = path;
 this.events.publish("changeToMap",true);
     // this.navCtrl.setRoot(LeafletmapPage,{path: path});
}

publishPath(){
  this.events.publish("selectedPath",this.path);
}




}



// WEBPACK FOOTER //
// ./src/pages/paths-list/paths-list.ts